import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";

export function NotificationBell() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user || user.scope === "platform") return;
    const load = () => api.get("/notifications", { params: { status: "unread", limit: 1 } })
      .then(({ data }) => setCount(data.unread_count || 0))
      .catch(() => undefined);
    void load();
    const update = (event: Event) => setCount(Number((event as CustomEvent<number>).detail) || 0);
    window.addEventListener("remedikeep:notification-count", update);
    return () => window.removeEventListener("remedikeep:notification-count", update);
  }, [user]);

  if (!user || user.scope === "platform") return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/notifications")}
      className="relative grid h-10 w-10 place-items-center rounded-full border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900"
      aria-label={count ? `Notifications, ${count} unread` : "Notifications"}
      title="Notifications"
      data-testid="header-notifications"
    >
      <Bell className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 min-w-5 rounded-full bg-red-600 px-1.5 py-0.5 text-center text-[10px] font-semibold text-white">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
